import { Section } from 'foundations-components/transitional/components/Section';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { CitationQuestion } from '../Citation/CitationQuestion';
import { CitationSummary } from '../Citation/CitationSummary';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CitationPopoverBody = ({
  citation
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(CitationQuestion, {
        citation: citation
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Tile, {
        compact: true,
        children: /*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(CitationSummary, {
            citation: citation
          })
        })
      })
    })]
  });
};